import { instance } from "api/apiBase";
import {
  Lockbox,
  GetLockboxesParams,
  GetLockboxesResponse,
  LockboxPayload,
  VerifyResult,
  GenerateLockboxCodePayload,
  GeneratedLockboxCode
} from "./types";

const api = {
  getLockboxes: async (
    params: GetLockboxesParams = {}
  ): Promise<GetLockboxesResponse> => {
    return (await instance.get("/portal/v1/boom_crm/lockboxes", { params }))
      .data;
  },

  getLockbox: async (id: number): Promise<Lockbox> => {
    return (await instance.get(`/portal/v1/boom_crm/lockboxes/${id}`)).data;
  },

  createLockbox: async (data: LockboxPayload): Promise<Lockbox> => {
    return (await instance.post("/portal/v1/boom_crm/lockboxes", data)).data;
  },

  updateLockbox: async (
    id: number,
    data: Partial<LockboxPayload>
  ): Promise<Lockbox> => {
    return (await instance.patch(`/portal/v1/boom_crm/lockboxes/${id}`, data))
      .data;
  },

  deleteLockbox: async (id: number): Promise<void> => {
    await instance.delete(`/portal/v1/boom_crm/lockboxes/${id}`);
  },

  // Verifies the lockbox against its real vendor. Always resolves with a result envelope
  // (a failed verification is HTTP 200 with verified:false); only network/5xx/auth throw.
  verifyLockbox: async (id: number): Promise<VerifyResult> => {
    return (await instance.post(`/portal/v1/boom_crm/lockboxes/${id}/verify`))
      .data;
  },

  generateCode: async (
    id: number,
    data: GenerateLockboxCodePayload = {}
  ): Promise<GeneratedLockboxCode> => {
    return (
      await instance.post(
        `/portal/v1/boom_crm/lockboxes/${id}/generate_code`,
        data
      )
    ).data;
  }
};

export default api;
